import {create, StateCreator} from 'zustand';
import {OrderingTypeStore, initialState} from './types';
import actions from './actions';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const orderingTypeStore: StateCreator<
  OrderingTypeStore,
  [['zustand/devtools', never], ['zustand/immer', never]]
> = (set, get) => ({
  ...initialState,
  ...actions(set, get)
});

const orderStoreCreator = create<OrderingTypeStore>();

export type OrderingStoreInstance = ReturnType<typeof orderStoreCreator>;

export const createOrderingStoreInstance = () =>
  orderStoreCreator(devtools(immer(orderingTypeStore), {name: 'ordering-type'}));
export * from './types';
export * from './actions';
